module.exports = __webpack_public_path__ + "static/img/demandInfoDetail_process.3a4889b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/demandInfoDetail_process.png
// module id = DnuK
// module chunks = 2